import { StyleSheet, Text, View } from 'react-native';
import { colors, control, fontFamily, radii, spacing } from '~/ui/tokens';

export type BadgeVariant = 'brand' | 'success' | 'neutral';

interface BadgeProps {
  label: string;
  variant?: BadgeVariant;
}

export function Badge({ label, variant = 'neutral' }: BadgeProps) {
  const palette = variantPalette[variant];
  return (
    <View style={[styles.base, { backgroundColor: palette.background }]}>
      <Text style={[styles.label, { color: palette.text }]}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  base: {
    alignSelf: 'flex-start',
    borderRadius: radii.full,
    paddingVertical: spacing(0.75),
    paddingHorizontal: spacing(1.25),
  },
  label: {
    fontFamily: fontFamily.semibold,
    ...control.badge,
  },
});

const variantPalette: Record<BadgeVariant, { background: string; text: string }> = {
  brand: { background: colors.indigoTint, text: colors.indigo },
  success: { background: colors.greenTint, text: colors.green },
  neutral: { background: colors.lineSoft, text: colors.inkFaint },
};
